module.exports = __webpack_public_path__ + "bdb1e7c2561e9318a8a6c4b3c5a1e888.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/city-6.png
 ** module id = 1042
 ** module chunks = 0
 **/